import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import Header from './components/Header';
import Body from './components/Body';
import valuationSlice from './slice';

import { ValutionPageContainer } from './styled';

function Valuation() {
  const dispatch = useDispatch();
  const { setIsMobileView } = valuationSlice.actions;

  useEffect(() => {
    let timeoutId = null;
    const checkWindowWidth = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const { innerWidth: width } = window;

        if (width <= 796) {
          dispatch(setIsMobileView(true));
        } else {
          dispatch(setIsMobileView(false));
        }
      }, 16);
    };

    window.addEventListener('resize', checkWindowWidth);
    window.addEventListener('DOMContentLoaded', checkWindowWidth);
  }, []);

  return (
    <ValutionPageContainer>
      <Header />
      <Body />
    </ValutionPageContainer>
  );
}

export default Valuation;
